import { render, staticRenderFns } from "./HotApp.vue?vue&type=template&id=096bf283&scoped=true&"
import script from "./HotApp.vue?vue&type=script&lang=js&"
export * from "./HotApp.vue?vue&type=script&lang=js&"
import style0 from "./HotApp.vue?vue&type=style&index=0&id=096bf283&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096bf283",
  null
  
)

export default component.exports